import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { Flex, Box } from "grid-styled";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { reduxForm, Field } from "redux-form";
import { validate as buildValidations, validators } from "validate-redux-form";
import { notEmpty, EMAIL_REGEX } from "../utils/validation";
import { logIn } from "../ducks/auth";
import Alert from "./Alert";
import { InputContainer } from "./forms";
import Button from "./Button";
import LoginWrapper from "./LoginWrapper";
import * as colors from "../settings/colors";

const ForgotPasswordLink = styled(Link)`
  display: block;
  color: ${colors.TAB_TEXT};
  font-size: 13px;
`;

const validate = values => {
  return buildValidations(values, {
    username: validators.regex(EMAIL_REGEX)(
      "Please enter a valid email address."
    ),
    password: notEmpty()("Please enter a password.")
  });
};

class Login extends React.Component {
  state = {
    redirectToReferrer: false
  };

  login = values => {
    const { username, password } = values;
    return this.props.logIn(username, password).then(() => {
      if (!this.props.loginError) {
        this.setState({ redirectToReferrer: true });
      }
    });
  };

  render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }

    return (
      <LoginWrapper>
        <Helmet>
          <title>Login</title>
        </Helmet>
        <form onSubmit={this.props.handleSubmit(this.login)}>
          {this.props.loginError && (
            <Box pb={2}>
              <Alert>There was a problem logging you in.</Alert>
            </Box>
          )}
          <Box pb={2}>
            <Field
              size="large"
              name="username"
              labelText="Email Address"
              placeholder="e.g., john@archadeck.net"
              component={InputContainer}
            />
          </Box>
          <Box pb={3}>
            <Field
              size="large"
              name="password"
              type="password"
              labelText="Password"
              placeholder="e.g., •••••••••••"
              component={InputContainer}
            />
          </Box>
          <Flex align="center" justify="space-between">
            <Button variant="primary" type="submit">
              Log In
            </Button>
            <ForgotPasswordLink to="/reset-password">
              Forgot your password?
            </ForgotPasswordLink>
          </Flex>
        </form>
      </LoginWrapper>
    );
  }
}

const formName = "login";

const enhance = compose(
  connect(
    state => ({
      loginError: state.auth.error
    }),
    {
      logIn
    }
  ),
  reduxForm({
    form: formName,
    validate
  })
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js